<template>
  <div v-if="menu">
    <div class="bg-light p-3 my-2 rounded">
      <b-row class="m-0 justify-content-between">
        <b-col>
          <b-row class="m-0 pb-0">
            <h5>
              <font-awesome-icon style="z-index: 2000" @click="openInfoModal" class="mr-2 hover text-info" :icon="['fas', 'info-circle']"/>
              <font-awesome-icon v-if="menu.img" style="z-index: 2000" @click="openInfoModal" class="mr-2 hover text-info" :icon="['fas', 'image']"/>
              <span v-if="menu.number">{{menu.number}} - </span>{{menu.title}}
            </h5>
          </b-row>
          <p class="m-0 mb-2">{{menu.description}}</p>
          <h5 class="text-info mb-0 pb-0 when-closed">{{getExtrasPrice(menu)}}€</h5>
        </b-col>
        <b-col cols="3" class=" text-right" >
          <font-awesome-icon v-show="menu.extras.length == 0 && menu.variants.length == 0" @click="addToCart(menu)" style="z-index: 2000" class="ml-2 pt-1 h2 hover text-info" :icon="['fas', 'shopping-cart']"/>
          <div v-b-toggle="'menu-'+menu._id" >
            <font-awesome-icon v-show="menu.extras.length > 0 || menu.variants.length > 0" style="z-index: 2000" class="ml-2 pt-1 h2 hover text-info when-closed" :icon="['fas', 'plus']"/>
            <font-awesome-icon v-show="menu.extras.length > 0 || menu.variants.length > 0" style="z-index: 2000" class="ml-2 pt-1 h2 hover text-info when-open" :icon="['fas', 'minus']"/>
          </div>
        
        </b-col>
      </b-row>
      <b-collapse :id="'menu-'+menu._id" class="mt-2 " accordion="menuItem-accordion" v-if="menu.extras.length > 0 || menu.variants.length > 0">

        <div v-if="menu.variants">
          <b-row class="m-0 mx-3 pb-4 justify-content-start" v-if="menu.variants.length > 0">
            <div class="w-100 pt-2" v-for="menuVariant in menu.variants" :key="menuVariant.index">
              <p class="m-0">{{ menuVariant.title }}</p>
              <b-form-select :state="!menuVariant.choosen ? false : true" v-model="menuVariant.choosen" style="width: 350px" :options="getOptions(menuVariant)" size="sm" class="mt-2"></b-form-select>
            </div>
          </b-row>
        </div>
        
        <b-row class="m-0 mx-3 justify-content-start">
          
          <div class="w-100">
            <b-form-checkbox
            size="lg"
            class="mt-1"
            v-for="extra in menu.extras.slice(0, 5)" :key="extra.index"
              v-model="extra.choosen"
            >
              <p class="m-0">{{ extra.title }} + {{ calcExtraPrice(extra) }}€</p>
            </b-form-checkbox>
            <b-collapse :id="'extra-'+menu._id">

                <b-form-checkbox
                size="lg"
                class="mt-1"
                v-for="extra in menu.extras.slice(5, menu.extras.length)" :key="extra.index"
                  v-model="extra.choosen"
                >
                  <p class="m-0">{{ extra.title }} + {{ calcExtraPrice(extra) }}€</p>
                </b-form-checkbox>
                
            </b-collapse>
            <b-row class="m-0 mt-3 justify-content-start" v-b-toggle="'extra-'+menu._id" v-if="menu.extras.length > 5">
              <font-awesome-icon class="when-open" style="font-size: 20px; cursor: pointer" :icon="['fas', 'chevron-up']"/>
              <p class="ml-2 when-open">weniger anzeigen</p>
              <font-awesome-icon class="when-closed" style="font-size: 20px; cursor: pointer" :icon="['fas', 'chevron-down']"/>
              <p class="ml-2 when-closed">weitere {{ menu.extras.length - 5 }} anzeigen</p>
            </b-row>
           

          </div>

        </b-row>
        
        <b-row class="m-0 mt-3 justify-content-end">
           <h4 class="mr-3 mt-1 text-info mb-0 pb-0">{{getExtrasPrice(menu)}}€</h4>
          <div v-if="menu.variants">
            <font-awesome-icon @click="addToCart(menu)" style="z-index: 2000" class="mr-2 pt-1 h2 hover text-info" :icon="menu.variants.find(variant => !variant.choosen) ? ['fas', 'ban'] : ['fas', 'shopping-cart']"/>
          </div>
          <div v-else>
            <font-awesome-icon @click="addToCart(menu)" style="z-index: 2000" class="mr-2 pt-1 h2 hover text-info" :icon="['fas', 'shopping-cart']"/>
          </div>
        </b-row>
    </b-collapse>

    </div>
      <b-modal v-model="infoModal" size="lg" hide-footer hide-header >
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark" >Produktinformationen</h4>
          <font-awesome-icon @click="infoModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <div class="m-3">

          <h4 class="mb-4  text-center text-dark" >{{ menu.title }}</h4>

          <div v-if="menu.img">
            <b-img-lazy :src="getImage(menu.img.image)" class="rounded shadow mb-3" fluid :alt="menu.img.name"></b-img-lazy>
          </div>

          <div v-if="menu.additives">
            <h5 v-show="menu.additives.length > 0" class="text-left ml-3">Zusatzstoffe:</h5>
            <ul class="m-0" v-for="additive in menu.additives" :key="additive.index">
                <li class="m-0">{{ additive.description }}</li>
            </ul>
          </div>

          <div v-if="menu.allergens">
            <h5 v-show="menu.allergens.length > 0" class="mt-3 text-left ml-3">Allergene:</h5>
            <ul class="m-0" v-for="allergen in menu.allergens" :key="allergen.index">
              <li class="m-0 mb-2">{{ allergen.title }} {{ allergen.description }}</li>
            </ul>
          </div>

          <div v-if="menu.allergens && menu.additives">
            <h5 v-show="menu.allergens.length == 0 && menu.additives.length == 0" class="mt-3 text-left">Hinweis:</h5>
            <small>Informationen zu Zusatzstoffen und Allergenen liegen in der Regel in den Restaurants aus.</small>

          </div>
          
          <div class="py-3">
           <small >Es kann vorkommen, dass die angezeigten Informationen unvollständig sind.</small>
           <small > Bitte wende dich direkt an das jeweilige Restaurant, wenn Allergien oder Unverträglichkeiten vorliegen.</small>
          </div>
        </div>
       
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'MenuItem',

  props: {
    menuItem: null
  },
  components: {

  },
  data: () => {
    return {
      menu: null,
      infoModal: false
    }
  },
  watch: {
    
  },
  computed: {
    
  },
  mounted(){
    this.menu = JSON.parse(JSON.stringify(this.menuItem))
  },
  methods: {
    getImage(img){
      return process.env.VUE_APP_API_BASEURL + '/' + img
    },
    calcExtraPrice(extra){
      var price = extra.price

      if(!this.menu.variants) return price
      if(this.menu.variants.length > 0){
        this.menu.variants.forEach(variant => {
          if(variant.choosen){
            price += variant.choosen.extra_price
          }
        })
      }

      return price.toFixed(2)
    },
    getOptions(variants){
      var array = []
      var option = {}
        if(variants.variants){
          variants.variants.forEach(element => {
            if(element.price > 0){
              option = {value: element, text: element.title + ' ( +' + element.price.toFixed(2) +'€ )'}
            }else{
              option = {value: element, text: element.title}
            }
            array.push(option)
          });
        }
      
      return array.sort( this.compareVariants )
    },
    compareVariants( a, b ) {


        var A = a.value.price
        var B = b.value.price
        if ( A < B ){
          return -1;
        }
        if ( A > B ){
          return 1;
        }
        return 0;

    },
    addToCart(menu){
      if(menu.variants){
        if(menu.variants.find(variant => !variant.choosen)) return
      }
      
      this.$emit('addToCart', this.menu);
    },
    openInfoModal(){
      this.infoModal = true
    },
    getExtrasPrice(menu){
      var price = menu.price
      menu.extras.forEach(element => {
        if(element.choosen){
          price += element.price
          if(this.menu.variants.length > 0){
            this.menu.variants.forEach(variant => {
              if(variant.choosen){
                price += variant.choosen.extra_price
              }
            })
          }
        }
      });
      if(menu.variants){
        if(menu.variants.find(variant => variant.choosen)){
          menu.variants.filter(variant => variant.choosen).forEach(element => {
            price += element.choosen.price 
          })
        }
      }
      return price.toFixed(2)
    },
  }
}
</script>

<style lang="scss" >

  .outer-preview {
    display: table;
    position: relative;
    top: 0;
    left: 0;
    height: 200px;
    width: 100%;
  }

  .middle-preview {
    display: table-cell;
    vertical-align: middle;
  }

  .inner-preview {
    margin-left: auto;
    margin-right: auto;
  }

</style>
